import {environment} from '../environments/environment';
import Bugsnag from '@bugsnag/js';
import {CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {SharedModule} from './shared/shared.module';
import {RouterModule} from '@angular/router';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {AppLightRoutingModule} from './core/modules/app-light-routing/app-light-routing.module';
import {AppDefaultRoutingModule} from './core/modules/app-default-routing/app-default-routing.module';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport} from '@angular/common/http';
import {TokenInterceptor} from './core/interceptors/token.interceptor';
import {NotLoggedInInterceptor} from './core/interceptors/not-logged-in.interceptor';
import {EffectsModule} from '@ngrx/effects';
import {
  PropertyDetailsEffects,
  PropertyNotesEffects,
  PropertyUploadsEffects,
  SimilarPropertiesEffects
} from './store/effects/property';
import {StoreModule} from '@ngrx/store';
import * as fromProperty from './store/reducers/property';
import * as fromUser from './store/reducers/user';
import * as fromCalendar from './store/reducers/calendar';
import {AgentDetailsEffects, CurrentUserEffects, EstateAgentEffects, SellerDetailsEffects} from './store/effects/user';
import {CalendarWidgetEffects} from './store/effects/calendar';
import {userMetaReducers} from './store/metareducers/user';
import {devToolsModules} from './build-specifics';
import {InitEffects} from './store/effects/init/init.effects';
import {ToastrModule} from 'ngx-toastr';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TooltipModule} from '@amin-karimi/ng2-tooltip-directive';
import {GlobalErrorHandlerService} from './core/services/global-error-handler.service';
import {StripeComponent} from './core/components/checkout/stripe/stripe.component';
import {CCPaymentComponent} from './modules/mos/components/ccpayment/ccpayment.component';
import {PusherService, PUSHER_SERVICE} from './shared/services/pusher/pusher.service';

if (environment.bugsnagActive && environment.bugsnagActive !== 'false') {
  Bugsnag.start({apiKey: environment.bugsnagKey, appVersion: environment.version.replace(/ /g, ''), releaseStage: environment.appEnv});
}

// tslint:disable-next-line:typedef
export function errorHandlerFactory() {
  return new GlobalErrorHandlerService(Bugsnag);
}

@NgModule({
  declarations: [
    AppComponent,
    StripeComponent,
    CCPaymentComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent], imports: [BrowserModule,
    SharedModule,
    AppDefaultRoutingModule,
    AppLightRoutingModule,
    DragDropModule,
    RouterModule.forRoot([
      {path: 'as', loadChildren: () => import('./modules/amplify/amplify.module').then(m => m.AmplifyModule)},
      {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
      {path: '**', redirectTo: 'dashboard', pathMatch: 'full'},
    ], {
      bindToComponentInputs: true,
      paramsInheritanceStrategy: 'always',
    }),
    StoreModule.forRoot({
      property: fromProperty.reducers,
      user: fromUser.reducers,
      calendar: fromCalendar.reducers
    }, {
      metaReducers: userMetaReducers
    }),
    EffectsModule.forRoot([
      PropertyDetailsEffects,
      PropertyNotesEffects,
      PropertyUploadsEffects,
      AgentDetailsEffects,
      SellerDetailsEffects,
      SimilarPropertiesEffects,
      CalendarWidgetEffects,
      CurrentUserEffects,
      EstateAgentEffects,
      InitEffects
    ]),
    devToolsModules,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    TooltipModule
  ],
  providers: [
    {provide: ErrorHandler, useFactory: errorHandlerFactory},
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: NotLoggedInInterceptor, multi: true},
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    PusherService,
    {provide: PUSHER_SERVICE, useExisting: PusherService},
  ]
})
export class AppModule {
}
